import { render, staticRenderFns } from "./OrderHistoryAddToCartButton.vue?vue&type=template&id=4f2761c3&scoped=true&"
import script from "./OrderHistoryAddToCartButton.vue?vue&type=script&lang=ts&"
export * from "./OrderHistoryAddToCartButton.vue?vue&type=script&lang=ts&"
import style0 from "./OrderHistoryAddToCartButton.vue?vue&type=style&index=0&id=4f2761c3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2761c3",
  null
  
)

export default component.exports